import { RefabricProURL } from "../index";
import { IGetSharedReportsResponse } from "./reports.type";

// `HttpClient.get` returns the JSON body, and this endpoint's body is the array itself (no `responseData` envelope), so
// the method resolves to the array. A handled 401/403 resolves to a `{ _handled: true }` object instead — callers check
// `Array.isArray` (`[HTTP_HANDLED_RESPONSE]`). The `as unknown as` cast bridges HttpClient's blanket `ApiResponse<T>`.
export default {
  async getSharedReports(): Promise<IGetSharedReportsResponse> {
    return RefabricProURL.get("reports") as unknown as Promise<IGetSharedReportsResponse>;
  },
};
